import type { State } from '../../../state'

export const closeDetailsProducer = (state: State): State => ({
  ...state,
  current: undefined,
  content: 'list',
})
